import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Item } from './item';

const MypageIpList = observer(({ items = [] }) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (items.length > 0) {
      setIsLoading(false);
    } else {
      setIsLoading(true);
    }
  }, [items])

  return (
    <div>
      {
        !isLoading && !!items && items.map((item, i) => <Item item={item} key={i} />)
      }
    </div>
  );
});

export {
  MypageIpList
};
